import { ProductType, PlannerEcsSystem, EventComponent, EntityColorComponent, AlbedoColor } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils, TransformUtils } from '@inter-ikea-core/core';
import InvalidPlacedInteriorComponent from '../components/InvalidPlacedInteriorComponent';
/**
 * Marks drawers and wirebasket red if they are above allowed (market specific) height or inside wallhanged frame
 */
export class InteriorPlacementValidationSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'InteriorPlacementValidationSystem', EventComponent.id);
        this.maxAllowedHeight = 1200;
        this.country = '';
        this.handleSouthKoreaSpecificDrawerRules = (frame, drawer) => {
            // South Korea has special rules where drawers are allowed up to 120cm if stack has open space or door. Otherwise max height is 72cm.
            const framesInStack = [
                ...this.coreApi.entities.getDescendantsWithComponent(frame, ComponentIds.FRAME_COMPONENT_ID),
                frame,
                ...this.coreApi.entities.getAncestorsWithComponent(frame, ComponentIds.FRAME_COMPONENT_ID)
            ];
            const drawersInStack = framesInStack.flatMap(frame => this.coreApi.entities
                .getFrameDescendants(frame)
                .filter(child => child.hasComponent(ComponentIds.DRAWER_COMPONENT_ID)));
            const stackHeight = framesInStack.reduce((totalHeight, entity) => {
                const frameHeight = this.coreApi.entities.getEntityComSize(entity)?.height || 0;
                return totalHeight + frameHeight;
            }, 0);
            const drawersHeight = drawersInStack.reduce((totalHeight, entity) => {
                const drawerHeight = this.coreApi.entities.getEntityComSize(entity)?.height || 0;
                return totalHeight + drawerHeight;
            }, 0);
            const stackOnlyContainsDrawers = stackHeight === drawersHeight;
            const maxDrawerHeight = stackOnlyContainsDrawers ? 720 : 1200;
            const drawerPosition = TransformUtils.worldPosition(drawer);
            if (drawerPosition.Y > maxDrawerHeight) {
                this.setValidPlacement(drawer, false);
            }
            else {
                this.setValidPlacement(drawer, true);
            }
        };
        this.coreApi = coreApi;
    }
    onAdd(entity, newComponent) {
        if (['history', 'load'].includes(newComponent.event)) {
            this.handleEntity();
        }
    }
    onUpdate(entity, oldComponent, newComponent) {
        if (['history', 'load'].includes(newComponent.event)) {
            this.handleEntity();
        }
    }
    onRemove() { }
    handleEntity() {
        const drawersAndWirebaskets = this.coreApi.entities.getByProductTypes([
            ProductType.SMASTAD_WIRE_BASKET_ASM,
            ProductType.SMASTAD_DRAWER_ASM
        ]);
        drawersAndWirebaskets.forEach(entity => {
            const position = TransformUtils.worldPosition(entity);
            const frame = HierarchyUtils.parent(entity);
            if (frame &&
                !this.coreApi.entities.isEntityPlacedOnFloor(frame) &&
                !this.coreApi.entities.isPartOfFloorstandingStack(frame)) {
                this.setValidPlacement(entity, false);
            }
            else if (frame &&
                this.coreApi.entities.isProductType(entity, ProductType.SMASTAD_DRAWER_ASM) &&
                this.country === 'KR') {
                this.handleSouthKoreaSpecificDrawerRules(frame, entity);
            }
            else if (position.Y > this.maxAllowedHeight) {
                this.setValidPlacement(entity, false);
            }
            else {
                this.setValidPlacement(entity, true);
            }
        });
    }
    setValidPlacement(entity, validPlacement) {
        entity.removeComponent(EntityColorComponent.id);
        if (validPlacement) {
            entity.removeComponent(InvalidPlacedInteriorComponent.id);
            entity.addComponent(new EntityColorComponent(AlbedoColor.NONE));
        }
        else {
            entity.addComponent(new InvalidPlacedInteriorComponent());
            entity.addComponent(new EntityColorComponent(AlbedoColor.RED));
        }
    }
    setMarketMaxAllowedHeight(maxAllowedHeight, country) {
        this.maxAllowedHeight = maxAllowedHeight;
        this.country = country;
    }
}
//# sourceMappingURL=InteriorPlacementValidationSystem.js.map